import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import modernHouse from "../media/img/backgrounds/modern-apartment.jpg";
import Propertii from "./common/Propertii";

class Logout extends Propertii {

    /**
     * Clear the localStorage, as the user has manually logged out.
     */
    componentDidMount() {

        localStorage.removeItem('token_type');
        localStorage.removeItem('access_token');
        localStorage.removeItem('expires_in');
        localStorage.removeItem('status');
        localStorage.removeItem('screening');
        localStorage.removeItem('broadcast_messages');
        sessionStorage.removeItem('session_role_id');

        this.props.refreshAppState();
    }

    /**
     * Render the component.
     *
     * @returns {*} - A splash page where the user is directed to upon logging out.
     */
    render() {

        return(
            <div className="content-block">

                <div className="jumbotron jumbotron-fluid mb-0" style={{background: `linear-gradient(20deg, rgb(79, 79, 79) 0%, rgba(17, 17, 17, 0.38) 100%) 0% 0% / cover, url('${modernHouse}') no-repeat center center scroll`}}>
                    <div className={`container text-md-center`}>
                        <h1 className="display-5 pt-3 text-white">
                            <FormattedMessage id="static.logout.heading" />
                        </h1>
                        <p className="lead text-white">
                            <FormattedMessage id="static.logout.subheading" />
                        </p>
                    </div>
                </div>

                <div className="container">

                    <div className="row">
                        <div className="col">
                            <h5 className="mb-5">
                                <FormattedMessage id="static.logout.body" />
                            </h5>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col align-self-center">
                                            <FormattedMessage id="static.logout.help.heading" />
                                        </div>
                                        <div className="col align-self-center">
                                            <div className="float-right">
                                                <a href="http://rentmoola.zendesk.com/" target="_blank" className="btn btn-primary btn-sm" rel="noopener noreferrer">
                                                    <FormattedMessage id="static.logout.help.button" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-4 align-self-center text-center">
                                            <FontAwesomeIcon icon={['fal', 'question-circle']} className={`fa-fw text-primary py-3`} size="7x" />
                                        </div>
                                        <div className="col-8 align-self-center">
                                            <p className="card-text mb-0">
                                                <FormattedMessage id="static.logout.help.body" />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col align-self-center">
                                            <FormattedMessage id="static.logout.review.heading" />
                                        </div>
                                        <div className="col align-self-center">
                                            <div className="float-right">
                                                <a href="https://www.google.com/maps/place/RentMoola/@49.2849156,-123.1247816,17z/data=!3m1!4b1!4m5!3m4!1s0x54867181b6f5ddb9:0xa906c3dd1fde9d86!8m2!3d49.2849156!4d-123.1225929" target="_blank" className="btn btn-primary btn-sm" rel="noopener noreferrer">
                                                    <FormattedMessage id="static.logout.review.button" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-4 align-self-center text-center">
                                            <FontAwesomeIcon icon={['fal', 'smile']} className={`fa-fw text-primary py-3`} size="7x" />
                                        </div>
                                        <div className="col-8 align-self-center">
                                            <p className="card-text mb-0">
                                                <FormattedMessage id="static.logout.review.body" />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        )
    };
}

Logout.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Logout);